import { Injectable } from '@angular/core';
import { IContext } from '../utils/contextkey';

export type SimpleContextValue = undefined | string | boolean;

/**
 * Provides ambient simple context for the application.
 * "simple" means the context values should be `undefined` / `string` / `boolean`.
 */
export interface IContextService extends IContext {
    setValue(key: string, value: SimpleContextValue | (() => SimpleContextValue)): void;
}

@Injectable({
    providedIn: 'root'
})
export class ContextService implements IContextService {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _contextDict: { [key: string]: SimpleContextValue | (() => SimpleContextValue) };
    public constructor() {
        this._contextDict = {};
        // set defaults
        // Whether to enable ADF preset keybindings (currently for testing purpose).
        this.setValue('keyboardEnableDefaults', true);
    }
    public getValue<T>(key: string): T | undefined {
        let value = this._contextDict[key];
        if (typeof value === 'function') {
            value = value();
        }
        // TODO We may need to change return type of `getValue` from T into something more specific.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return value as any as T;
    }
    public setValue(key: string, value: SimpleContextValue | (() => SimpleContextValue)): void {
        if (value === undefined) {
            delete this._contextDict[key];
        } else {
            this._contextDict[key] = value;
        }
    }
}
